var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTelegram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.81536 14.5587C8.8284 14.3258 8.92248 14.1047 9.08131 13.9338L17.3635 5.02282C17.7378 4.62677 17.2818 4.43363 16.7849 4.79287L6.69689 12.3809C6.42448 12.5858 6.06647 12.6378 5.74701 12.519L1.71339 11.018C0.73159 10.6595 0.724544 9.85518 1.93382 9.27688L19.6498 1.13231C20.4589 0.694332 21.2398 1.36402 20.931 2.84054L17.9139 19.7913C17.7032 20.9959 17.0928 21.284 16.247 20.7276L12.4094 17.3471C11.9919 16.9794 11.3546 17.0231 10.9912 17.4444L9.44205 19.2403C9.42941 19.255 9.41689 19.2695 9.40446 19.2839C9.02945 19.7188 8.54949 19.306 8.5816 18.7326L8.81536 14.5587Z",
    stroke: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.3a91ed6c.svg";
export { ForwardRef as ReactComponent };